import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useClientAuth } from '../contexts/ClientAuthContext'
import { Loader2 } from 'lucide-react'

interface ProtectedClientRouteProps {
  children: ReactNode
}

const ProtectedClientRoute = ({ children }: ProtectedClientRouteProps) => {
  const { isAuthenticated, isLoading } = useClientAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
        <span className="ml-2 text-lg">Loading...</span>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/client/login" replace />
  }

  return <>{children}</>
}

export default ProtectedClientRoute